import { ActionContext } from "vuex";
import statementUseCases from "../../../../domain/usecase/impl/statement/statementUseCases";
import { Statement } from "../../../../domain/entities/statement";
import { Order } from "../../../../domain/entities/order";
import { ListResponse } from "../../../../domain/entities/shop/product/listResponse";

class StatementState {
  statements: Statement[] = [];
  numberOfPagesstatements = 1;
}

const state = new StatementState();

const mutations = {
  LOAD_STATEMENT(state: StatementState, statements: Statement[] | null): void {
    state.statements = statements ?? [];
  },
  SET_PAGES_STATEMENT(state: StatementState, numberOfPagesstatements: number) {
    state.numberOfPagesstatements = numberOfPagesstatements;
  }
};

const actions = {
  async loadStatements(
    { commit }: ActionContext<StatementState, StatementState>,
    payload: {
      order: Order;
    }
  ): Promise<void> {
    const response: ListResponse<Statement[]> = await statementUseCases.list(
      payload.order
    );
    commit("LOAD_STATEMENT", response.items);
    commit("SET_PAGES_STATEMENT", response.page);
  }
};

const getters = {
  statements: (state: StatementState): Statement[] => state.statements,
  numberOfPagesstatements: (state: StatementState): number =>
    state.numberOfPagesstatements || 1
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
